module.exports = __webpack_public_path__ + "img/why-icon-active-4.814311da.svg";